import * as React from 'react';

import { Button } from 'components/bootstrap';
import { Icon } from 'components/common';
import { Col, Row } from 'common/components/layout-styles';

type Props = {
  onCancel: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onFromLibrary: () => void;
  onNewEventProcedure: () => void;
};

function NewButtons({ onCancel, onFromLibrary, onNewEventProcedure }: Props) {
  return (
    <Col $gap="xs">
      <p>There are no Event Procedures configured for this entity yet.</p>
      <Row $align="center">
        <Button onClick={onCancel}>Cancel</Button>
        <Button onClick={onFromLibrary}>
          <Icon name="assignment_add" />
          From Library
        </Button>
        <Button bsStyle="primary" onClick={onNewEventProcedure}>
          <Icon name="add" />
          New Event Procedure
        </Button>
      </Row>
    </Col>
  );
}

export default NewButtons;
